import { Component, HostBinding, Input } from '@angular/core';
import { HeadingType } from 'src/app/shared/components/heading/heading.types';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'mable-tip',
  standalone: true,
  templateUrl: './tip.component.html',
  styleUrls: ['./tip.component.scss'],
  imports: [SharedModule],
})
export class TipComponent {
  // The icon to display in the tip heading
  @Input() icon: string;

  // The color of the icon in the tip heading
  @Input() iconColor = '';

  // The heading text for the tip component
  @Input() heading: string;

  /**
   * Background color for the tip component.
   * DS colors are white, grey-100 and lilac-50
   */
  @Input() backgroudColor = '';

  // Heading type/size (e.g., 'h3').
  @Input() headingType: HeadingType = 'h3';

  // Host binding to apply dynamic classes based on the background color.
  @HostBinding('class') get tipColor() {
    return `ion-color-${this.backgroudColor || 'grey-50'}`;
  }
}
